import { useEffect, useState } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#202835] shadow-lg' : 'bg-transparent'}`}>
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            <a className="flex items-center" href="/">
              <img 
                alt="شركة الهمة الذهبية" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
              />
            </a>

            <nav className="hidden lg:flex items-center gap-8">
              <a 
                className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group text-[#d4af37]" 
                href="#home"
                onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
              >
                الرئيسية
                <span className="absolute bottom-0 right-0 w-full h-0.5 bg-[#d4af37]"></span>
              </a>
              <a 
                className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" 
                href="#about"
                onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}
              >
                من نحن
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </a>
              <a 
                className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" 
                href="#services"
                onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}
              >
                الخدمات
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </a>
              <a 
                className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" 
                href="#projects"
                onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}
              >
                المشاريع
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </a>
              <a 
                className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" 
                href="/news"
              >
                الأخبار
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </a>
            </nav>

            <a 
              className="hidden lg:block px-8 py-3 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer" 
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}
            >
              تواصل معنا
            </a>

            <button 
              className="lg:hidden text-white text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#202835] border-t border-white/10">
            <nav className="container mx-auto px-6 py-4 flex flex-col gap-4">
              <a className="text-white font-semibold hover:text-[#d4af37] transition-colors" href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>الرئيسية</a>
              <a className="text-white font-semibold hover:text-[#d4af37] transition-colors" href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>من نحن</a>
              <a className="text-white font-semibold hover:text-[#d4af37] transition-colors" href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>الخدمات</a>
              <a className="text-white font-semibold hover:text-[#d4af37] transition-colors" href="#projects" onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}>المشاريع</a>
              <a className="text-white font-semibold hover:text-[#d4af37] transition-colors" href="/news">الأخبار</a>
              <a className="text-white font-semibold hover:text-[#d4af37] transition-colors" href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>تواصل معنا</a>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section id="home" className="relative h-screen w-full overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img 
            alt="شركة الهمة الذهبية للمقاولات" 
            className="w-full h-full object-cover object-center" 
            src="https://public.readdy.ai/ai/img_res/4ffb98d8ddd89d14ef6ea40f0814a2b0.jpg"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#202835]/70 via-[#202835]/60 to-[#202835]/70"></div>
        </div>

        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-6 text-center">
            <div>
              <img 
                alt="شركة الهمة الذهبية" 
                className="h-32 w-auto mx-auto mb-8" 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
              />
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
              نبني المستقبل... بالهمة والإتقان
            </h1>
            <div className="w-20 h-0.5 bg-[#d4af37] mx-auto mb-6"></div>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-12 leading-relaxed">
              شركة الهمة الذهبية - رائدة في مجال الإنشاءات العامة والمقاولات بأعلى معايير الجودة والاحترافية
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="#about" 
                className="px-10 py-4 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-xl flex items-center gap-3 cursor-pointer whitespace-nowrap"
                onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}
              >
                اعرف المزيد
                <i className="ri-arrow-down-line"></i>
              </a>
              <a 
                href="#projects" 
                className="px-10 py-4 border-2 border-[#d4af37] text-[#d4af37] font-bold rounded-full hover:bg-[#d4af37] hover:text-white transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
                onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}
              >
                استكشف المشاريع
              </a>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#d4af37] rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-2 bg-[#d4af37] rounded-full animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-3 order-2 lg:order-1">
              <div className="w-20 h-1 bg-[#d4af37] mb-6"></div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#202835] mb-4">شركة الهمة الذهبية</h2>
              <h3 className="text-2xl font-semibold text-[#d4af37] mb-8">الريادة في الإنشاءات والمقاولات</h3>
              <div className="space-y-6 text-lg text-[#202835]/80 leading-relaxed">
                <p>
                  شركة الهمة الذهبية هي شركة رائدة تعمل في مجال الإنشاءات العامة للمقاولات، حيث تقدم الشركة للعميل خدمات متكاملة تشمل التشييد والبناء والترميم وتمديد الأنابيب بمختلف أنواعها وتمديد الأسلاك الكهربائية وأسلاك الاتصالات.
                </p>
                <p>
                  نقدم خدمات التركيب والصيانة للخدمات الثقيلة وتشمل الأعمال الميكانيكية، الأعمال الكهربائية، أعمال التيار الخفيف، والأعمال المدنية. كما تعمل الشركة على خدمات النظافة للمرافق والمناظر الطبيعية.
                </p>
                <p>
                  مع فريق من الخبراء والمتخصصين، نسعى لتحقيق رؤيتنا في أن نكون الخيار الأول للمستثمرين والباحثين عن التميز في قطاع المقاولات والإنشاءات.
                </p>
              </div>
            </div>
            <div className="lg:col-span-2 order-1 lg:order-2">
              <div className="relative w-full h-[500px]">
                <img 
                  alt="شركة الهمة الذهبية" 
                  className="w-full h-full object-cover object-center rounded-2xl shadow-2xl" 
                  src="https://readdy.ai/api/search-image?query=Professional%20construction%20team%20reviewing%20architectural%20blueprints%20at%20modern%20building%20site%2C%20engineers%20and%20contractors%20in%20safety%20helmets%20examining%20plans%2C%20high-quality%20construction%20project%20management%20scene%20with%20steel%20structures%20in%20background%2C%20corporate%20photography%20style%20with%20natural%20lighting&width=800&height=1000&seq=about-team-construction-001&orientation=portrait"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/20 to-transparent rounded-2xl"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Values Section */}
      <section id="vision" className="py-32 bg-gradient-to-b from-[#202835] to-[#151b24] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">رؤيتنا ومهمتنا</h2>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <div className="bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-2xl p-10 text-white">
              <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-3xl font-bold mb-6 text-[#d4af37]">رؤيتنا</h3>
              <div className="space-y-4 text-white/90 leading-relaxed">
                <p>
                  نسعى لأن نكون رواد في مجال الترميم والتشغيل والصيانة في المملكة العربية السعودية وتقديم أعلى معايير الجودة والابتكار، لنضفي حياة جديدة على كل ما نعمل عليه، ونعزز الاستدامة والتفوق في كل مشروع والمساهمة في تحقيق رؤية المملكة 2030.
                </p>
                <p>
                  نحن في شركتنا نؤمن بقوة التحول، ونسعى دائمًا لإعادة الحياة إلى المنشآت من خلال خبراتنا المتميزة في الترميم والصيانة، لنقدم بيئات عمل ملهمة ومستدامة.
                </p>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-2xl p-10 text-white">
              <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-compass-3-line text-3xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-3xl font-bold mb-6 text-[#d4af37]">مهمتنا</h3>
              <div className="space-y-4 leading-relaxed text-white/90">
                <p>
                  تتمثل مهمتنا في تقديم خدمات ترميم وتشغيل وصيانة متكاملة، تساهم في تعزيز الاستدامة وتحسين الأداء التشغيلي للمرافق، مع توفير حلول موثوقة وفعالة تتسم بالكفاءة والجودة.
                </p>
                <p>
                  نحن نلتزم بتقديم خدمات ترميم وتشغيل وصيانة عالية الجودة تهدف إلى الحفاظ على سلامة وكفاءة المنشآت والمرافق، مع التركيز على الابتكار والالتزام بالمواعيد.
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-xl p-10 text-center group hover:border-[#d4af37] transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-medal-line text-4xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">الجودة والتميز</h3>
              <p className="text-white/80 leading-relaxed">
                نلتزم بتقديم خدمات عالية الجودة في جميع جوانب الترميم والتشغيل والصيانة
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-xl p-10 text-center group hover:border-[#d4af37] transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-lightbulb-line text-4xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">الابتكار والتطوير</h3>
              <p className="text-white/80 leading-relaxed">
                نؤمن بقوة الابتكار ونعمل باستمرار على تحسين تقنياتنا وأساليبنا
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-xl p-10 text-center group hover:border-[#d4af37] transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-leaf-line text-4xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">الاستدامة</h3>
              <p className="text-white/80 leading-relaxed">
                نسعى لضمان استدامة المنشآت من خلال توفير حلول صيانة صديقة للبيئة
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-xl p-10 text-center group hover:border-[#d4af37] transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-4xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">السلامة والأمان</h3>
              <p className="text-white/80 leading-relaxed">
                سلامة العمل وأمان الموظفين والعملاء هي أولويتنا القصوى
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-32 bg-[#faf8f3]">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#202835] mb-4">خدماتنا</h2>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer">
              <div className="relative w-full h-[200px] overflow-hidden">
                <img 
                  alt="الإنشاءات" 
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=Modern%20high-rise%20building%20construction%20site%20with%20tower%20cranes%20and%20concrete%20structure%2C%20professional%20construction%20workers%20on%20scaffolding%2C%20urban%20development%20project%20with%20steel%20framework%2C%20corporate%20construction%20photography%20with%20blue%20sky%20background%20and%20professional%20quality&width=600&height=400&seq=service-construction-building-001&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/50 to-transparent"></div>
              </div>
              <div className="p-8">
                <div className="w-10 h-10 bg-[#d4af37]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-building-line text-2xl text-[#d4af37]"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#202835] mb-4">الإنشاءات</h3>
                <p className="text-[#202835]/70 leading-relaxed mb-6">
                  نقدم خدمات التشييد والبناء المتكاملة بأعلى معايير الجودة والاحترافية، من التخطيط حتى التسليم النهائي.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer">
              <div className="relative w-full h-[200px] overflow-hidden">
                <img 
                  alt="الترميم" 
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=Building%20renovation%20and%20restoration%20work%20in%20progress%2C%20construction%20workers%20repairing%20and%20upgrading%20commercial%20building%20facade%2C%20professional%20renovation%20project%20with%20scaffolding%20and%20modern%20equipment%2C%20corporate%20construction%20photography%20with%20clean%20composition&width=600&height=400&seq=service-renovation-repair-001&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/50 to-transparent"></div>
              </div>
              <div className="p-8">
                <div className="w-10 h-10 bg-[#d4af37]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-hammer-line text-2xl text-[#d4af37]"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#202835] mb-4">الترميم</h3>
                <p className="text-[#202835]/70 leading-relaxed mb-6">
                  خدمات ترميم شاملة للمباني والمنشآت، نعيد الحياة للمباني القديمة بأحدث التقنيات والمواد.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer">
              <div className="relative w-full h-[200px] overflow-hidden">
                <img 
                  alt="تمديدات الأنابيب" 
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=Industrial%20piping%20system%20installation%20in%20modern%20building%2C%20professional%20plumbers%20installing%20large%20diameter%20pipes%20and%20valves%2C%20mechanical%20engineering%20construction%20work%20with%20metal%20pipes%20and%20fittings%2C%20technical%20construction%20photography%20with%20professional%20lighting&width=600&height=400&seq=service-piping-plumbing-001&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/50 to-transparent"></div>
              </div>
              <div className="p-8">
                <div className="w-10 h-10 bg-[#d4af37]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-water-flash-line text-2xl text-[#d4af37]"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#202835] mb-4">تمديدات الأنابيب</h3>
                <p className="text-[#202835]/70 leading-relaxed mb-6">
                  تمديد الأنابيب بمختلف أنواعها بأعلى معايير الجودة والسلامة، مع ضمان الأداء الأمثل.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer">
              <div className="relative w-full h-[200px] overflow-hidden">
                <img 
                  alt="الأعمال الكهربائية" 
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=Electrical%20installation%20work%20in%20commercial%20building%2C%20professional%20electrician%20installing%20cable%20trays%20and%20wiring%20systems%2C%20modern%20electrical%20panel%20and%20distribution%20boards%2C%20technical%20construction%20photography%20with%20industrial%20lighting%20and%20clean%20background&width=600&height=400&seq=service-electrical-wiring-001&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/50 to-transparent"></div>
              </div>
              <div className="p-8">
                <div className="w-10 h-10 bg-[#d4af37]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-flashlight-line text-2xl text-[#d4af37]"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#202835] mb-4">الأعمال الكهربائية</h3>
                <p className="text-[#202835]/70 leading-relaxed mb-6">
                  تمديد الأسلاك الكهربائية وأسلاك الاتصالات، التركيب والصيانة للأنظمة الكهربائية بجميع أنواعها.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer">
              <div className="relative w-full h-[200px] overflow-hidden">
                <img 
                  alt="الأعمال الميكانيكية" 
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=HVAC%20mechanical%20systems%20installation%20in%20modern%20building%2C%20professional%20technicians%20installing%20air%20conditioning%20units%20and%20ventilation%20ducts%2C%20industrial%20mechanical%20equipment%20and%20pumps%2C%20technical%20construction%20photography%20with%20professional%20quality&width=600&height=400&seq=service-mechanical-hvac-001&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/50 to-transparent"></div>
              </div>
              <div className="p-8">
                <div className="w-10 h-10 bg-[#d4af37]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-settings-3-line text-2xl text-[#d4af37]"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#202835] mb-4">الأعمال الميكانيكية</h3>
                <p className="text-[#202835]/70 leading-relaxed mb-6">
                  التركيب والصيانة للخدمات الميكانيكية، التكييف، التهوية، المضخات، والسباكة بأعلى كفاءة.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer">
              <div className="relative w-full h-[200px] overflow-hidden">
                <img 
                  alt="أنظمة السلامة" 
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=Fire%20safety%20system%20installation%20in%20commercial%20building%2C%20professional%20technician%20installing%20fire%20sprinklers%20and%20alarm%20systems%2C%20red%20fire%20extinguisher%20and%20safety%20equipment%2C%20technical%20construction%20photography%20with%20professional%20lighting%20and%20clean%20composition&width=600&height=400&seq=service-fire-safety-001&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835]/50 to-transparent"></div>
              </div>
              <div className="p-8">
                <div className="w-10 h-10 bg-[#d4af37]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-fire-line text-2xl text-[#d4af37]"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#202835] mb-4">أنظمة السلامة</h3>
                <p className="text-[#202835]/70 leading-relaxed mb-6">
                  تركيب وصيانة أنظمة الإطفاء، الإنذار، حساسات الحريق، وأنظمة الإطفاء بالغازات.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="py-32 bg-[#202835] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">مشاريعنا</h2>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto mb-6"></div>
            <p className="text-white/80 text-xl max-w-2xl mx-auto">
              نفخر بتقديم مشاريع متميزة في مجال الإنشاءات والمقاولات بأعلى معايير الجودة
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="group cursor-pointer">
              <div className="relative w-full h-[400px] rounded-xl overflow-hidden">
                <img 
                  alt="مشروع مصرف الراجحي" 
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=Modern%20fireproof%20storage%20room%20construction%20with%20steel%20framework%20and%20fire-resistant%20materials%2C%20industrial%20warehouse%20facility%20with%20advanced%20safety%20systems%2C%20professional%20construction%20project%20with%20mechanical%20and%20electrical%20installations%2C%20corporate%20photography%20with%20clean%20background&width=800&height=1000&seq=project-fireproof-storage-001&orientation=portrait"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835] via-[#202835]/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-[#d4af37] text-white text-sm font-semibold rounded-full mb-3">
                    مكتمل
                  </span>
                  <h3 className="text-2xl font-bold text-white mb-2">غرفة مقاومة للحريق - مصرف الراجحي</h3>
                  <p className="text-[#d4af37] mb-3 flex items-center gap-2">
                    <i className="ri-map-pin-line"></i>
                    الرياض - مخرج 16
                  </p>
                  <p className="text-white/80 text-sm">
                    إنشاء غرفة بمساحة 900 م² مقاومة للحريق شاملة جميع الأعمال الميكانيكية والكهربائية والمدنية
                  </p>
                </div>
              </div>
            </div>

            <div className="group cursor-pointer">
              <div className="relative w-full h-[400px] rounded-xl overflow-hidden">
                <img 
                  alt="ترميم غرفة صرافة" 
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=Bank%20branch%20interior%20renovation%20project%2C%20modern%20banking%20hall%20with%20teller%20counters%20and%20customer%20service%20area%2C%20professional%20commercial%20renovation%20with%20elegant%20finishes%20and%20lighting%2C%20corporate%20photography%20with%20clean%20professional%20style&width=800&height=1000&seq=project-bank-renovation-001&orientation=portrait"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835] via-[#202835]/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-[#d4af37] text-white text-sm font-semibold rounded-full mb-3">
                    مكتمل
                  </span>
                  <h3 className="text-2xl font-bold text-white mb-2">ترميم غرفة صرافة</h3>
                  <p className="text-[#d4af37] mb-3 flex items-center gap-2">
                    <i className="ri-map-pin-line"></i>
                    الرياض
                  </p>
                  <p className="text-white/80 text-sm">
                    ترميم وصيانة غرفة صرافة بالكامل خاصة بمصرف الراجحي بأعلى معايير الجودة
                  </p>
                </div>
              </div>
            </div>

            <div className="group cursor-pointer">
              <div className="relative w-full h-[400px] rounded-xl overflow-hidden">
                <img 
                  alt="أنظمة السلامة - الدمام" 
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500" 
                  src="https://readdy.ai/api/search-image?query=Fire%20safety%20system%20installation%20with%20water%20tanks%20and%20fire%20pumps%2C%20professional%20fire%20protection%20equipment%20and%20sprinkler%20systems%20in%20commercial%20building%2C%20industrial%20safety%20infrastructure%20with%20red%20pipes%20and%20valves%2C%20technical%20construction%20photography%20with%20professional%20quality&width=800&height=1000&seq=project-fire-system-dammam-001&orientation=portrait"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#202835] via-[#202835]/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-[#d4af37] text-white text-sm font-semibold rounded-full mb-3">
                    مكتمل
                  </span>
                  <h3 className="text-2xl font-bold text-white mb-2">أنظمة السلامة والحريق</h3>
                  <p className="text-[#d4af37] mb-3 flex items-center gap-2">
                    <i className="ri-map-pin-line"></i>
                    الدمام - فروع متعددة
                  </p>
                  <p className="text-white/80 text-sm">
                    توريد وتركيب وفحص أنظمة الحريق الكاملة شاملة الخزانات والمضخات والتمديدات
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img 
            alt="إنجازاتنا" 
            className="w-full h-full object-cover object-center" 
            src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20large%20construction%20site%20with%20multiple%20cranes%20and%20buildings%20under%20development%2C%20professional%20construction%20workers%20coordinating%20on%20site%2C%20urban%20development%20project%20with%20steel%20structures%20and%20concrete%2C%20corporate%20construction%20photography%20with%20dramatic%20lighting%20and%20professional%20quality&width=1920&height=1080&seq=stats-construction-aerial-001&orientation=landscape"
          />
          <div className="absolute inset-0 bg-[#202835]/85"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-time-line text-3xl text-[#d4af37]"></i>
              </div>
              <div className="text-6xl md:text-7xl font-bold text-[#d4af37] mb-2">
                15<span className="text-5xl">+</span>
              </div>
              <p className="text-xl text-white font-semibold">سنوات الخبرة</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-building-2-line text-3xl text-[#d4af37]"></i>
              </div>
              <div className="text-6xl md:text-7xl font-bold text-[#d4af37] mb-2">
                100<span className="text-5xl">+</span>
              </div>
              <p className="text-xl text-white font-semibold">مشروع منجز</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-emotion-happy-line text-3xl text-[#d4af37]"></i>
              </div>
              <div className="text-6xl md:text-7xl font-bold text-[#d4af37] mb-2">
                98<span className="text-5xl">%</span>
              </div>
              <p className="text-xl text-white font-semibold">رضا العملاء</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-team-line text-3xl text-[#d4af37]"></i>
              </div>
              <div className="text-6xl md:text-7xl font-bold text-[#d4af37] mb-2">
                50<span className="text-5xl">+</span>
              </div>
              <p className="text-xl text-white font-semibold">فريق محترف</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="relative py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            alt="تواصل معنا" 
            className="w-full h-full object-cover object-center" 
            src="https://readdy.ai/api/search-image?query=Modern%20construction%20office%20building%20exterior%20at%20sunset%2C%20professional%20corporate%20headquarters%20with%20glass%20facade%20and%20elegant%20architecture%2C%20business%20contact%20and%20communication%20concept%2C%20corporate%20photography%20with%20warm%20golden%20lighting%20and%20professional%20quality&width=1920&height=1080&seq=contact-office-building-001&orientation=landscape"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#202835]/95 via-[#202835]/90 to-[#202835]/95"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center mx-auto">
                <i className="ri-customer-service-2-line text-3xl text-white"></i>
              </div>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">تواصل معنا</h2>
            <p className="text-xl text-white/80 max-w-2xl mx-auto">
              نحن هنا للإجابة على استفساراتك ومساعدتك في تحقيق مشاريعك
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:border-[#d4af37] transition-all duration-300 group">
              <div className="w-14 h-14 bg-[#d4af37]/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#d4af37] transition-colors duration-300">
                <i className="ri-phone-line text-2xl text-[#d4af37] group-hover:text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-3">اتصل بنا</h3>
              <p className="text-white text-lg mb-2" dir="ltr">+966 50 016 5920</p>
              <p className="text-white text-lg mb-2" dir="ltr">+966 50 125 5250</p>
              <p className="text-white/60 text-sm">السبت - الخميس: 8 ص - 5 م</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:border-[#d4af37] transition-all duration-300 group">
              <div className="w-14 h-14 bg-[#d4af37]/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#d4af37] transition-colors duration-300">
                <i className="ri-mail-line text-2xl text-[#d4af37] group-hover:text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-3">راسلنا</h3>
              <p className="text-white text-lg mb-2">info@gmcc.com.sa</p>
              <p className="text-white/60 text-sm">نرد خلال 24 ساعة</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:border-[#d4af37] transition-all duration-300 group md:col-span-2 lg:col-span-1">
              <div className="w-14 h-14 bg-[#d4af37]/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#d4af37] transition-colors duration-300">
                <i className="ri-map-pin-line text-2xl text-[#d4af37] group-hover:text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-3">موقعنا</h3>
              <p className="text-white text-lg mb-2">المملكة العربية السعودية</p>
              <p className="text-white/60 text-sm">نخدم جميع مناطق المملكة</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-[#202835] text-white overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <a className="inline-block mb-6" href="/">
                <img 
                  alt="شركة الهمة الذهبية" 
                  className="h-16 w-auto" 
                  src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
                />
              </a>
              <p className="text-white/80 leading-relaxed mb-6">
                شركة الهمة الذهبية، شريكك الموثوق في عالم المقاولات والإنشاءات. نقدم حلولاً متكاملة تلبي تطلعاتكم وتحقق أحلامكم.
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#1877f2] transition-all duration-300 cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-black transition-all duration-300 cursor-pointer">
                  <i className="ri-twitter-x-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#0077b5] transition-all duration-300 cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#e4405f] transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-fill"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">روابط سريعة</h3>
              <ul className="space-y-3">
                <li>
                  <a 
                    className="text-white/80 hover:text-[#d4af37] transition-colors duration-300 flex items-center gap-2 group cursor-pointer" 
                    href="#about"
                    onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}
                  >
                    <i className="ri-arrow-left-s-line text-[#d4af37] group-hover:translate-x-1 transition-transform duration-300"></i>
                    من نحن
                  </a>
                </li>
                <li>
                  <a 
                    className="text-white/80 hover:text-[#d4af37] transition-colors duration-300 flex items-center gap-2 group cursor-pointer" 
                    href="#services"
                    onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}
                  >
                    <i className="ri-arrow-left-s-line text-[#d4af37] group-hover:translate-x-1 transition-transform duration-300"></i>
                    خدماتنا
                  </a>
                </li>
                <li>
                  <a 
                    className="text-white/80 hover:text-[#d4af37] transition-colors duration-300 flex items-center gap-2 group cursor-pointer" 
                    href="#projects"
                    onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}
                  >
                    <i className="ri-arrow-left-s-line text-[#d4af37] group-hover:translate-x-1 transition-transform duration-300"></i>
                    مشاريعنا
                  </a>
                </li>
                <li>
                  <a 
                    className="text-white/80 hover:text-[#d4af37] transition-colors duration-300 flex items-center gap-2 group cursor-pointer" 
                    href="/news"
                  >
                    <i className="ri-arrow-left-s-line text-[#d4af37] group-hover:translate-x-1 transition-transform duration-300"></i>
                    الأخبار
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">خدماتنا</h3>
              <ul className="space-y-3">
                <li className="text-white/80 flex items-center gap-2">
                  <i className="ri-arrow-left-s-line text-[#d4af37]"></i>
                  الإنشاءات والبناء
                </li>
                <li className="text-white/80 flex items-center gap-2">
                  <i className="ri-arrow-left-s-line text-[#d4af37]"></i>
                  الترميم والصيانة
                </li>
                <li className="text-white/80 flex items-center gap-2">
                  <i className="ri-arrow-left-s-line text-[#d4af37]"></i>
                  الأعمال الكهربائية
                </li>
                <li className="text-white/80 flex items-center gap-2">
                  <i className="ri-arrow-left-s-line text-[#d4af37]"></i>
                  أنظمة السلامة
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">تواصل معنا</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-map-pin-line text-[#d4af37] text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <span>المملكة العربية السعودية</span>
                </li>
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-phone-line text-[#d4af37] text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <div dir="ltr">+966 50 016 5920</div>
                    <div dir="ltr">+966 50 125 5250</div>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-mail-line text-[#d4af37] text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <span>info@gmcc.com.sa</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 py-6">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4">
              <p className="text-white/60 text-sm text-center">
                © 2024 شركة الهمة الذهبية. جميع الحقوق محفوظة.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
